module.exports = __webpack_public_path__ + "img/淮北市人民医院.45a92465.png";